import { SidePanelProps } from '@mews/b2b-ui';
import { lt } from '@mews/framework';
import { ModalSidePanel } from '@mews-commander/ui';
import { ProductCheckListLinkButton, ProductsContent, ProductsContentProps } from './components';

type ProductsContainerProps = Pick<SidePanelProps, 'opened' | 'onClose'> & Partial<ProductsContentProps>;

export const ProductsContainer = ({ onClose, opened, reservationId, ...props }: ProductsContainerProps) => (
    <ModalSidePanel
        opened={opened}
        onClose={onClose}
        title={lt('Products')}
        headerActions={null}
        width="small"
        actions={<ProductCheckListLinkButton />}
        content={reservationId ? <ProductsContent reservationId={reservationId} {...props} /> : null}
    />
);
